// extracted by mini-css-extract-plugin
export default {"main":"MainLayout_main__txPOL","main__body":"MainLayout_main__body__ZEu+f"};